module.exports = __webpack_public_path__ + "img/architecture3.a943bdff.jpg";